import { type PackagingInformationEntry, type WarehouseStockData } from "../../models/ProductData";

const EMPTY_LIST: WarehouseStockData[] = [];

const selectAllWarehouses = (packageInfo?: PackagingInformationEntry | null): WarehouseStockData[] => {
  return packageInfo ? [packageInfo.global, ...packageInfo.warehouses] : EMPTY_LIST;
};

export const selectPackageInStockAmount = (packageInfo?: PackagingInformationEntry | null) => {
  return selectAllWarehouses(packageInfo)
    .flatMap((wh) => wh.inStock)
    .reduce((sum, obj) => sum + obj.quantity, 0);
};

export const selectPackageIsInStock = (packageInfo?: PackagingInformationEntry | null) => {
  return selectPackageInStockAmount(packageInfo) > 0;
};

export const selectInProductionFlatList = (packageInfo: PackagingInformationEntry) => {
  const inProduction = selectAllWarehouses(packageInfo).flatMap((obj) => obj.inProduction);
  inProduction.sort((a, b) => a.date.getTime() - b.date.getTime());

  return inProduction;
};
